import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios";
import { URLS } from "constants/api.constants";

export const faqsGet = createAsyncThunk('faqs/faqs', async (params = {}, thunkAPI) => {
    try {
        const response = await axiosInstance.post(`${URLS.FAQS.GET_FAQS}?page=1`, params);
        
        if (response.data?.success) {
            return response.data;
        } else {
            return thunkAPI.rejectWithValue(response.data?.message || "Failed to fetch FAQs");
        }
    } catch (error) {
        console.error("FAQ API Error:", error);
        return thunkAPI.rejectWithValue(error?.message || "An error occurred while fetching FAQs");
    }
});